import React from 'react';
import {
  ActivityIndicator,
  ActivityIndicatorProps,
} from 'react-native';

import type { ColorType } from '@types';
import { useColors } from '@hooks';

export interface ILoaderProps extends ActivityIndicatorProps {
  color?: ColorType;
}

export function Loader({
  color = '$primary300',
  ...props
}: ILoaderProps) {
  const colors = useColors();

  return <ActivityIndicator color={colors[color]} {...props} />;
}
